/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 필터 토글 컴포넌트 (스페셜 노트)
 * 버전 : 1.0
 * 파일명 : ToggleTagNote.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-07-16
 * ================================================================ 

 *================================================================
 */

import { useEffect } from 'react'
import { Box, Button  } from '@mui/material'
import {styled} from '@mui/material'
import { useDialogStore } from 'src/stores/DialogStore';

// 필터 버튼 스타일
const FilterButton = styled(Button)(({ theme }) => ({
    margin: "5px",
    borderRadius: "20px",
    '&.selected': {
    backgroundColor: '#E5F4F8', 
    color: '#06799B',                        // 테두리와 글씨 색상
    border: '1px solid #06799B'         // 테두리 색상
    },
    '&.unselected': {
    backgroundColor: 'white',
    color: 'black',
    border: `1.5px solid ${theme.palette.grey[400]}`,
    },
}));

const TitleWrapper = styled('span')(({theme})=>({
    fontSize:'16px',
    fontWeight:500,
}))

const ToggleTagNote = () => {
    const temp_edu_level = useDialogStore((state)=>state.temp_edu_level)
    const temp_special_note = useDialogStore((state)=>state.temp_special_note)
    const toggleFilter = useDialogStore((state)=>state.toggleFilter)
    const syncField = useDialogStore((state)=>state.syncField)

    useEffect(()=>{
        syncField('special_note','temp','base')
    },[])
    const mapNote: Record<number,string>={
        0 : '무관',
        1 : '우대학과',
        2 : '학군단 설치',
        3 : '군협약'
    }

  return (
    <>
        <TitleWrapper>
            특이사항
        </TitleWrapper>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
            {[0, 1, 2, 3]
                .filter(note => {
                // 학군단은 고등학교만 선택됐을 때 제외
                if (note === 2 && temp_edu_level.length === 1 && temp_edu_level[0] === 1) return false;
                return true;
                })
                .map(note => (
                <FilterButton
                    key={note}
                    onClick={() => toggleFilter("temp_special_note", note, 0)}
                    className={temp_special_note.includes(note) ? "selected" : "unselected"}
                >
                    {mapNote[note]}
                </FilterButton>
                ))}
            </Box>
    </>
  )
}

export default ToggleTagNote